
export const state = {
  isOpenMenu: false,
  isOpenModal: false
}

